import React from "react";

export const CurrentplanSkeleton = () =>
    <div>
        <div className="mt-3">
            <div className="skeleton skeleton-title" ></div>
            <div className="skeleton skeleton-subtitle"></div>
        </div>
        <div className="mt-4 d-flex gap-2">
            <div className="skeleton" style={{ width: "120px", height: "36px", borderRadius: "10px" }}></div>
            <div className="skeleton" style={{ width: "120px", height: "36px", borderRadius: "10px" }}></div>
        </div>
    </div>

export const CurrentPlanProtag = () =>
    <div className="skeleton" style={{ width: "70px", height: "24px", borderRadius: "10px" }}></div>